export default {
  '--main-bg-color': {
    dark: 'rgb(56, 56, 56)',
    light: 'rgb(200, 220, 220)'
  },
  '--select-theme-color': {
    dark: 'rgb(240, 240, 240)',
    light: 'rgb(90, 90, 90)'
  },
  '--flag-hover-bg-color': {
    dark: 'rgba(200, 200, 200, 0.5)',
    light: 'rgba(150, 150, 150, 0.9)'
  },
  '--main-word-color': {
    dark: 'rgb(222, 222, 222)',
    light: 'rgb(80, 80, 80)'
  },
  '--footer-bg-color': {
    dark: 'rgb(43, 43, 43)',
    light: 'rgb(161, 181, 188)'
  },
  '--pause-color': {
    dark: 'rgb(245, 245, 245)',
    light: 'rgb(105, 105, 105)'
  },
  '--timer-color': {
    dark: 'rgb(45, 190, 50)',
    light: 'rgb(55, 96, 49)'
  },
  '--loose-score-color': {
    dark: 'rgb(222, 91, 91)',
    light: 'rgb(222, 91, 91)'
  },
  '--welcome-color': {
    dark: 'rgb(245, 245, 245)',
    light: 'rgb(0, 0, 0)'
  },
  '--letter-bg-color': {
    dark: 'rgb(71, 132, 201)',
    light: 'rgb(255, 215, 118)'
  },
  '--letter-color': {
    dark: 'rgb(222, 222, 222)',
    light: 'rgb(70, 70, 70)'
  },
  '--words-bg-color': {
    dark: 'rgb(40, 40, 40)',
    light: 'rgb(240, 250, 250)'
  },
  '--word-color': {
    dark: 'rgb(222, 222, 222)',
    light: 'rgb(0, 0, 0)'
  },
  '--last-word-color': {
    dark: 'rgb(228, 79, 79)',
    light: 'rgb(248, 0, 0)'
  },
  '--tooltip-bg-color': {
    dark: 'rgb(85, 85, 85)',
    light: 'rgb(200, 200, 200)'
  }
}